import React from "react";
import styled from "styled-components";
import Brainstorm from "./links/Brainstorm";
import MaterialsToShare from "./links/MaterialsToShare";
import useScreenSize from "../../utils/useScreenSize";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 50px 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-around;
  @media only screen and (max-width: 600px) {
        flex-direction: column;
    
      }
`

const LinksBlock = () => {
    const {width} = useScreenSize();
    const isTablet = width <= 1000;
    const isMobile = width <= 600;
    return (
        <Wrapper>
            <a href={'https://drive.google.com/drive/folders/1VvnpmvYbBbUR6qRTwTjyW29DiPrpYWqh?usp=sharing'}>
                <MaterialsToShare width={isMobile ? '60vw' : isTablet ? '40vw' : '20vw'}/>
            </a>
            <a href={'https://docs.google.com/forms/d/e/1FAIpQLSdicJ4CYicm1QUVGe22_ug55J1zsZfhlKytkoFbafLIa_JhBA/viewform'}>
                <Brainstorm width={isMobile ? '60vw' : isTablet ? '40vw' : '20vw'}/>
            </a>
        </Wrapper>
    )
}

export default LinksBlock;
